import { render, staticRenderFns } from "./SimpleCalendar.vue?vue&type=template&id=2bdfec3e&"
import script from "./SimpleCalendar.vue?vue&type=script&lang=js&"
export * from "./SimpleCalendar.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports